export default "__VITE_ASSET__C5j7r7IY__"